import React, { useState, useEffect } from 'react';
import { Save, X } from 'lucide-react';

const ModalMedicaoEmLote = ({ isOpen, onClose, itens, onSalvar }) => {
  const [formData, setFormData] = useState({
    data: new Date().toISOString().split('T')[0],
    operacao: 'Medição',
    numeroMedicao: 1,
    itensQuantidades: []
  });

  useEffect(() => {
    if (isOpen && itens) {
      try {
        // Determinar o próximo número de medição - verificando todos os itens
        let todosNumerosMedicao = [];
        
        // Percorrer todos os itens e seus detalhes para coletar todos os números de medição
        itens.forEach(item => {
          if (item.detalhes && Array.isArray(item.detalhes)) {
            item.detalhes.forEach(detalhe => {
              if (detalhe && detalhe.operacao === 'Medição') {
                // Tentar obter o número da medição de várias formas possíveis
                let num = null;
                
                if (detalhe.numeroMedicao !== undefined && detalhe.numeroMedicao !== null) {
                  num = parseInt(detalhe.numeroMedicao);
                } else if (detalhe.numero_medicao !== undefined && detalhe.numero_medicao !== null) {
                  num = parseInt(detalhe.numero_medicao);
                } else if (detalhe.descricaoMedicao) {
                  // Tentar extrair o número da descrição (ex: "Medição 3")
                  const match = detalhe.descricaoMedicao.match(/\\d+/);
                  if (match) {
                    num = parseInt(match[0]);
                  }
                }
                
                if (!isNaN(num) && num > 0) {
                  todosNumerosMedicao.push(num);
                }
              }
            });
          }
        });
        
        // Ordenar os números para garantir que encontramos o maior
        todosNumerosMedicao.sort((a, b) => a - b);
        
        // Imprimir todos os números encontrados para debug
        console.log('Números de medição encontrados:', todosNumerosMedicao);
        
        // O próximo número é o maior encontrado + 1, ou 1 se nenhum foi encontrado
        const proximoNumero = todosNumerosMedicao.length > 0 ? 
          todosNumerosMedicao[todosNumerosMedicao.length - 1] + 1 : 1;
        
        console.log('Próximo número de medição calculado:', proximoNumero);
        
        // Inicializar o formulário com os itens e quantidades zeradas
        setFormData({
          data: new Date().toISOString().split('T')[0],
          operacao: 'Medição',
          numeroMedicao: proximoNumero,
          itensQuantidades: itens.map(item => {
            // Calcular o saldo disponível corretamente
            const qtdTotal = parseFloat(item.quantidade) || 0;
            const qtdMedida = parseFloat(item.quantidadeMedida) || 0;
            const saldoDisponivel = Math.max(0, qtdTotal - qtdMedida);
            
            return {
              itemId: item.id,
              item: item.item,
              descricao: item.descricao,
              unidade: item.unidade,
              preco: parseFloat(item.preco) || 0,
              quantidade: 0,
              quantidadeTotal: qtdTotal,
              quantidadeMedida: qtdMedida,
              saldoDisponivel: saldoDisponivel
            };
          })
        });
      } catch (error) {
        console.error('Erro ao calcular próximo número de medição:', error);
        // Em caso de erro, usar o valor padrão 1
        setFormData({
          data: new Date().toISOString().split('T')[0],
          operacao: 'Medição',
          numeroMedicao: 1,
          itensQuantidades: itens.map(item => ({
            itemId: item.id,
            item: item.item,
            descricao: item.descricao,
            unidade: item.unidade,
            preco: parseFloat(item.preco) || 0,
            quantidade: 0,
            quantidadeTotal: parseFloat(item.quantidade) || 0,
            quantidadeMedida: parseFloat(item.quantidadeMedida) || 0,
            saldoDisponivel: Math.max(0, (parseFloat(item.quantidade) || 0) - (parseFloat(item.quantidadeMedida) || 0))
          }))
        });
      }
    }
  }, [isOpen, itens]);

  const handleQuantidadeChange = (itemId, valor) => {
    setFormData(prev => ({
      ...prev,
      itensQuantidades: prev.itensQuantidades.map(item => 
        item.itemId === itemId ? { ...item, quantidade: parseFloat(valor) || 0 } : item
      )
    }));
  };

  const handleSubmit = () => {
    // Preparar os dados para salvar - incluir apenas itens com quantidade maior que zero
    const medicoes = formData.itensQuantidades
      .filter(item => parseFloat(item.quantidade) > 0)
      .map(item => ({
        itemId: item.itemId,
        data: formData.data,
        operacao: formData.operacao,
        numeroMedicao: parseInt(formData.numeroMedicao) || 1,
        descricaoMedicao: `Medição ${formData.numeroMedicao}`,
        quantidade: parseFloat(item.quantidade) || 0,
        valor: parseFloat(item.preco) || 0
      }));
    
    if (medicoes.length === 0) {
      alert('Nenhum item com quantidade informada. Por favor, informe a quantidade para pelo menos um item.');
      return;
    }
    
    onSalvar(medicoes);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '8px',
        padding: '20px',
        maxWidth: '900px',
        width: '90%',
        maxHeight: '90vh',
        overflowY: 'auto',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)'
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <h3 style={{ margin: 0 }}>Lançar Medição em Lote</h3>
          <button
            className="button secondary"
            onClick={onClose}
            style={{ padding: '8px' }}
          >
            <X size={16} />
          </button>
        </div>

        <div style={{ marginBottom: '20px' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '15px', marginBottom: '20px' }}>
            <div className="form-group">
              <label>Data da Medição</label>
              <input
                type="date"
                value={formData.data}
                onChange={(e) => setFormData({ ...formData, data: e.target.value })}
              />
            </div>
            <div className="form-group">
              <label>Operação</label>
              <select
                value={formData.operacao}
                onChange={(e) => setFormData({ ...formData, operacao: e.target.value })}
              >
                <option value="Medição">Medição</option>
                <option value="Ajuste">Ajuste</option>
                <option value="Correção">Correção</option>
              </select>
            </div>
            <div className="form-group">
              <label>Número da Medição</label>
              <input
                type="number"
                min="1"
                value={formData.numeroMedicao}
                onChange={(e) => setFormData({ ...formData, numeroMedicao: parseInt(e.target.value) || 1 })}
              />
            </div>
          </div>

          <div style={{ marginBottom: '10px', fontWeight: 'bold', color: '#0d6efd' }}>
            Medição {formData.numeroMedicao} - {formData.data}
          </div>

          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ backgroundColor: '#f8f9fa', borderBottom: '2px solid #dee2e6' }}>
                  <th style={{ padding: '10px', textAlign: 'left' }}>Item</th>
                  <th style={{ padding: '10px', textAlign: 'left' }}>Descrição</th>
                  <th style={{ padding: '10px', textAlign: 'center' }}>Un.</th>
                  <th style={{ padding: '10px', textAlign: 'right' }}>Preço Unit.</th>
                  <th style={{ padding: '10px', textAlign: 'right' }}>Qtd. Total</th>
                  <th style={{ padding: '10px', textAlign: 'right' }}>Já Medido</th>
                  <th style={{ padding: '10px', textAlign: 'right' }}>Saldo</th>
                  <th style={{ padding: '10px', textAlign: 'right' }}>Quantidade</th>
                </tr>
              </thead>
              <tbody>
                {formData.itensQuantidades.map((item) => (
                  <tr key={item.itemId} style={{ borderBottom: '1px solid #dee2e6' }}>
                    <td style={{ padding: '10px' }}>{item.item}</td>
                    <td style={{ padding: '10px' }}>{item.descricao}</td>
                    <td style={{ padding: '10px', textAlign: 'center' }}>{item.unidade}</td>
                    <td style={{ padding: '10px', textAlign: 'right' }}>
                      {new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(item.preco)}
                    </td>
                    <td style={{ padding: '10px', textAlign: 'right' }}>{item.quantidadeTotal}</td>
                    <td style={{ padding: '10px', textAlign: 'right' }}>{item.quantidadeMedida}</td>
                    <td style={{ padding: '10px', textAlign: 'right' }}>{item.saldoDisponivel.toFixed(2)}</td>
                    <td style={{ padding: '10px', textAlign: 'right' }}>
                      <input
                        type="number"
                        step="0.01"
                        min="0"
                        value={item.quantidade}
                        onChange={(e) => handleQuantidadeChange(item.itemId, e.target.value)}
                        style={{ width: '100px', textAlign: 'right' }}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '20px' }}>
          <button className="button secondary" onClick={onClose}>
            Cancelar
          </button>
          <button className="button" onClick={handleSubmit}>
            <Save size={16} />
            Salvar Medição
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalMedicaoEmLote;